module.exports = {"350430100":"濉溪镇","350430101":"里心镇","350430102":"溪口镇","350430103":"均口镇","350430201":"伊家乡","350430202":"黄坊乡","350430203":"溪源乡","350430204":"客坊乡","350430205":"黄埠乡","350430400":"福建建宁经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350430.json
// module id = 1099
// module chunks = 0